import type { PromptStore } from './types';

// Translation key constants for prompt editor
export const PROMPT_EDITOR_KEYS = {
  // Continue Writing
  continueWriting_name: 'common.continue_writing',
  continueWriting_minimax: 'common.continue_writing',

  // Summarize
  summarize_name: 'common.summarize',
  summarize_minimax: 'common.summarize',

  // Key Summary
  keySummary_name: 'common.summary',
  keySummary_minimax: 'common.summary',

  // Explain
  explain_name: 'components.ai_editor.menu_items.explain',
  explain_minimax: 'components.ai_editor.menu_items.prompt_explain',

  // Translate
  translate_name: 'common.translate',

  // Chinese (Simplified)
  simplifiedChinese_name: 'components.ai_editor.menu_items.lang_chinese_simplified',
  simplifiedChinese_minimax: 'components.ai_editor.menu_items.lang_chinese_simplified',

  // Chinese (Classical)
  classicalChinese_name: 'components.ai_editor.menu_items.lang_chinese_classical',
  classicalChinese_minimax: 'components.ai_editor.menu_items.lang_chinese_classical',

  // English
  english_name: 'components.ai_editor.menu_items.lang_english',
  english_minimax: 'components.ai_editor.menu_items.lang_english',

  // Korean
  korean_name: 'components.ai_editor.menu_items.lang_korean',
  korean_minimax: 'components.ai_editor.menu_items.lang_korean',

  // Japanese
  japanese_name: 'components.ai_editor.menu_items.lang_japanese',
  japanese_minimax: 'components.ai_editor.menu_items.lang_japanese',

  // French
  french_name: 'components.ai_editor.menu_items.lang_french',
  french_minimax: 'components.ai_editor.menu_items.lang_french',

  // German
  german_name: 'components.ai_editor.menu_items.lang_german',
  german_minimax: 'components.ai_editor.menu_items.lang_german',

  // Translate To
  translateTo_name: 'components.ai_editor.menu_items.translate_to_other',
  translateTo_minimax: 'components.ai_editor.menu_items.prompt_translate_to',

  // Improve Writing
  improveWriting_name: 'components.ai_editor.menu_items.improve_writing',
  improveWriting_minimax: 'components.ai_editor.menu_items.improve_writing',

  // Make Shorter
  makeShorter_name: 'components.ai_editor.menu_items.shorter',
  makeShorter_minimax: 'components.ai_editor.menu_items.shorter',

  // Make Longer
  makeLonger_name: 'components.ai_editor.menu_items.longer',
  makeLonger_minimax: 'components.ai_editor.menu_items.longer',

  // Switch Style
  switchStyle_name: 'components.ai_editor.menu_items.switch_style',

  // More Professional
  moreProfessional_name: 'components.ai_editor.menu_items.style_professional',
  moreProfessional_minimax: 'components.ai_editor.menu_items.style_professional',

  // Informal
  informal_name: 'components.ai_editor.menu_items.style_casual',
  informal_minimax: 'components.ai_editor.menu_items.style_casual',

  // More Direct
  moreDirect_name: 'components.ai_editor.menu_items.style_straightforward',
  moreDirect_minimax: 'components.ai_editor.menu_items.style_straightforward',

  // More Confident
  moreConfident_name: 'components.ai_editor.menu_items.style_confident',
  moreConfident_minimax: 'components.ai_editor.menu_items.style_confident',

  // More Friendly
  moreFriendly_name: 'components.ai_editor.menu_items.style_friendly',
  moreFriendly_minimax: 'components.ai_editor.menu_items.style_friendly',

  // Brainstorm
  brainstorm_placeholder: 'common.tell_ai_prompt',
  brainstorm_name: 'components.ai_editor.menu_items.brainstorm',
  brainstorm_minimax: 'components.ai_editor.menu_items.prompt_brainstorm',

  // Write an Article
  writeArticle_placeholder: 'common.tell_ai_prompt',
  writeArticle_name: 'components.ai_editor.menu_items.write_article',
  writeArticle_minimax: 'components.ai_editor.menu_items.prompt_blog',

  // Write an Outline
  writeOutline_placeholder: 'common.tell_ai_prompt',
  writeOutline_name: 'components.ai_editor.menu_items.write_outline',
  writeOutline_minimax: 'components.ai_editor.menu_items.prompt_outline',

  // Write a Story
  writeStory_placeholder: 'common.tell_ai_prompt',
  writeStory_name: 'components.ai_editor.menu_items.write_story',
  writeStory_minimax: 'components.ai_editor.menu_items.prompt_story',

  // Daily Notes
  dailyNotes_placeholder: 'common.tell_ai_prompt',
  dailyNotes_name: 'components.ai_editor.menu_items.daily_notes',
  dailyNotes_minimax: 'components.ai_editor.menu_items.prompt_daily_notes',

  // Pros and Cons Analysis
  prosConAnalysis_placeholder: 'common.tell_ai_prompt',
  prosConAnalysis_name: 'components.ai_editor.menu_items.analyze_pros_cons',
  prosConAnalysis_minimax: 'components.ai_editor.menu_items.prompt_pros_cons',

  // List Action Items
  listActionItems_placeholder: 'common.tell_ai_prompt',
  listActionItems_name: 'components.ai_editor.menu_items.list_action_steps',
  listActionItems_minimax: 'components.ai_editor.menu_items.prompt_action_items',

  // Explain (variant)
  explainVariant_name: 'components.ai_editor.menu_items.explain',
  explainVariant_minimax: 'components.ai_editor.menu_items.prompt_explain',

  // Draft with Multidimensional Table
  draftMultiTable_name: 'components.ai_editor.menu_items.draft_with_bitable',

  // Write a Plan
  writePlan_placeholder: 'common.tell_ai_prompt',
  writePlan_name: 'components.ai_editor.menu_items.write_plan',
  writePlan_minimax: 'components.ai_editor.menu_items.prompt_plan',

  // Write a List
  writeList_placeholder: 'common.tell_ai_prompt',
  writeList_name: 'components.ai_editor.menu_items.write_list',
  writeList_minimax: 'components.ai_editor.menu_items.prompt_list',

  // Task Management
  taskManagement_placeholder: 'common.tell_ai_prompt',
  taskManagement_name: 'components.ai_editor.menu_items.task_management',
  taskManagement_minimax: 'components.ai_editor.menu_items.prompt_task',

  // Other
  other_name: 'common.other',
  other_minimax: 'common.tell_ai_prompt',

  // Draft with Mind Map
  draftMindMap_name: 'components.ai_editor.menu_items.draft_with_mindmap',

  // Mind Outline
  mindOutline_name: 'components.ai_editor.menu_items.write_outline',
  mindOutline_minimax: 'components.ai_editor.menu_items.prompt_mindmap_outline',

  // Mind Plan
  mindPlan_name: 'components.ai_editor.menu_items.write_plan',
  mindPlan_minimax: 'components.ai_editor.menu_items.prompt_plan',

  // Mind Other
  mindOther_name: 'common.other',
  mindOther_minimax: 'common.tell_ai_prompt',
} as const;

const enRecords = {
  '9aab88e9-ba1b-4201-a9f3-483e814493db': {
    icon: 'IcEdit',
    name: PROMPT_EDITOR_KEYS.continueWriting_name,
    id: '9aab88e9-ba1b-4201-a9f3-483e814493db',
    type: 'ContinueWrite',
    minimax: PROMPT_EDITOR_KEYS.continueWriting_minimax,
  },
  '7aec37fa-f6be-4b6e-a870-6a54b430131a': {
    icon: 'IcSummarize',
    name: PROMPT_EDITOR_KEYS.summarize_name,
    id: '7aec37fa-f6be-4b6e-a870-6a54b430131a',
    type: 'Summarize',
    minimax: PROMPT_EDITOR_KEYS.summarize_minimax,
  },
  'c0e29509-ca71-4bc0-9a96-fa338a2b05ce': {
    icon: 'IcSummarize',
    name: PROMPT_EDITOR_KEYS.keySummary_name,
    id: 'c0e29509-ca71-4bc0-9a96-fa338a2b05ce',
    type: 'keySummary',
    minimax: PROMPT_EDITOR_KEYS.keySummary_minimax,
  },
  '5e936d14-2331-468b-af24-31433992451d': {
    icon: 'IcExplain',
    name: PROMPT_EDITOR_KEYS.explain_name,
    id: '5e936d14-2331-468b-af24-31433992451d',
    type: 'explain',
    minimax: PROMPT_EDITOR_KEYS.explain_minimax,
  },
  '5e936d14-2331-468b-af24-31433994451d': {
    icon: 'IcTranslate',
    name: PROMPT_EDITOR_KEYS.translate_name,
    id: '5e936d14-2331-468b-af24-31433994451d',
    subNodes: [
      '3a36576b-1b95-42c5-b70a-5c36fc9e145d',
      'fb5a9fbd-c969-4bf4-baee-a0d0af4cb880',
      '8846070a-7630-42a0-9042-290ab143d389',
      '6ecd1645-fadb-4f56-bec5-cb1877d16330',
      '069f3964-62a0-4094-96f9-b993dae8cc47',
      '9151b1e0-e57f-45fa-b4b2-3942ed8437e3',
      '459fee87-5cfc-4166-8b49-4060d4c27e2f',
      '459fee87-5cfc-4166-8b49-4060d4c27e22',
    ],
  },
  '3a36576b-1b95-42c5-b70a-5c36fc9e145d': {
    name: PROMPT_EDITOR_KEYS.simplifiedChinese_name,
    id: '3a36576b-1b95-42c5-b70a-5c36fc9e145d',
    type: 'simplified chinese',
    minimax: PROMPT_EDITOR_KEYS.simplifiedChinese_minimax,
  },
  'fb5a9fbd-c969-4bf4-baee-a0d0af4cb880': {
    name: PROMPT_EDITOR_KEYS.classicalChinese_name,
    id: 'fb5a9fbd-c969-4bf4-baee-a0d0af4cb880',
    type: 'classical chinese',
    minimax: PROMPT_EDITOR_KEYS.classicalChinese_minimax,
  },
  '8846070a-7630-42a0-9042-290ab143d389': {
    name: PROMPT_EDITOR_KEYS.english_name,
    id: '8846070a-7630-42a0-9042-290ab143d389',
    type: 'english',
    minimax: PROMPT_EDITOR_KEYS.english_minimax,
  },
  '6ecd1645-fadb-4f56-bec5-cb1877d16330': {
    name: PROMPT_EDITOR_KEYS.korean_name,
    id: '6ecd1645-fadb-4f56-bec5-cb1877d16330',
    type: 'korean',
    minimax: PROMPT_EDITOR_KEYS.korean_minimax,
  },
  '069f3964-62a0-4094-96f9-b993dae8cc47': {
    name: PROMPT_EDITOR_KEYS.japanese_name,
    id: '069f3964-62a0-4094-96f9-b993dae8cc47',
    type: 'japanese',
    minimax: PROMPT_EDITOR_KEYS.japanese_minimax,
  },
  '9151b1e0-e57f-45fa-b4b2-3942ed8437e3': {
    name: PROMPT_EDITOR_KEYS.french_name,
    id: '9151b1e0-e57f-45fa-b4b2-3942ed8437e3',
    type: 'french',
    minimax: PROMPT_EDITOR_KEYS.french_minimax,
  },
  '459fee87-5cfc-4166-8b49-4060d4c27e2f': {
    name: PROMPT_EDITOR_KEYS.german_name,
    id: '459fee87-5cfc-4166-8b49-4060d4c27e2f',
    type: 'german',
    minimax: PROMPT_EDITOR_KEYS.german_minimax,
  },
  '459fee87-5cfc-4166-8b49-4060d4c27e22': {
    name: PROMPT_EDITOR_KEYS.translateTo_name,
    id: '459fee87-5cfc-4166-8b49-4060d4c27e22',
    type: 'OtherLanguage',
    minimax: PROMPT_EDITOR_KEYS.translateTo_minimax,
  },
  '7edcb487-2041-4ade-8483-71b9e1caba35': {
    icon: 'IcChangeWriting',
    name: PROMPT_EDITOR_KEYS.improveWriting_name,
    id: '7edcb487-2041-4ade-8483-71b9e1caba35',
    type: 'Improve',
    minimax: PROMPT_EDITOR_KEYS.improveWriting_minimax,
  },
  '1a8812df-9395-4eed-84be-59b5e148e7c1': {
    icon: 'IcSimpler',
    name: PROMPT_EDITOR_KEYS.makeShorter_name,
    id: '1a8812df-9395-4eed-84be-59b5e148e7c1',
    type: 'makeShorter',
    minimax: PROMPT_EDITOR_KEYS.makeShorter_minimax,
  },
  '63c58833-d02c-4a15-8039-949c78bcc9f2': {
    icon: 'IcMoreDetail',
    name: PROMPT_EDITOR_KEYS.makeLonger_name,
    id: '63c58833-d02c-4a15-8039-949c78bcc9f2',
    type: 'makeLonger',
    minimax: PROMPT_EDITOR_KEYS.makeLonger_minimax,
  },
  '7613737d-eb65-4464-a596-167d1e3f0c00': {
    icon: 'IcAiStyle',
    name: PROMPT_EDITOR_KEYS.switchStyle_name,
    id: '7613737d-eb65-4464-a596-167d1e3f0c00',
    subNodes: [
      '32faf939-cb35-479f-95e8-3a234791a75d',
      '68dc99f8-ebda-440e-bd9d-b1d431b24e0a',
      'f57e6b90-d5c3-453a-87ab-e6ed9d2c175f',
      '06d15689-21c4-446d-89b0-fa5cc33c3d96',
      '6a8e29b8-e6ee-4af1-87da-212f01b7925a',
    ],
  },
  '32faf939-cb35-479f-95e8-3a234791a75d': {
    name: PROMPT_EDITOR_KEYS.moreProfessional_name,
    id: '32faf939-cb35-479f-95e8-3a234791a75d',
    type: 'professional',
    minimax: PROMPT_EDITOR_KEYS.moreProfessional_minimax,
  },
  '68dc99f8-ebda-440e-bd9d-b1d431b24e0a': {
    name: PROMPT_EDITOR_KEYS.informal_name,
    id: '68dc99f8-ebda-440e-bd9d-b1d431b24e0a',
    type: 'casual',
    minimax: PROMPT_EDITOR_KEYS.informal_minimax,
  },
  'f57e6b90-d5c3-453a-87ab-e6ed9d2c175f': {
    name: PROMPT_EDITOR_KEYS.moreDirect_name,
    id: 'f57e6b90-d5c3-453a-87ab-e6ed9d2c175f',
    type: 'straightforward',
    minimax: PROMPT_EDITOR_KEYS.moreDirect_minimax,
  },
  '06d15689-21c4-446d-89b0-fa5cc33c3d96': {
    name: PROMPT_EDITOR_KEYS.moreConfident_name,
    id: '06d15689-21c4-446d-89b0-fa5cc33c3d96',
    type: 'confident',
    minimax: PROMPT_EDITOR_KEYS.moreConfident_minimax,
  },
  '6a8e29b8-e6ee-4af1-87da-212f01b7925a': {
    name: PROMPT_EDITOR_KEYS.moreFriendly_name,
    id: '6a8e29b8-e6ee-4af1-87da-212f01b7925a',
    type: 'friendly',
    minimax: PROMPT_EDITOR_KEYS.moreFriendly_minimax,
  },
  'bc56080a-edb8-46e2-8584-7be4c4cc5d05': {
    icon: 'IcEdit',
    placeholder: PROMPT_EDITOR_KEYS.brainstorm_placeholder,
    name: PROMPT_EDITOR_KEYS.brainstorm_name,
    id: 'bc56080a-edb8-46e2-8584-7be4c4cc5d05',
    type: 'Brainstorm',
    minimax: PROMPT_EDITOR_KEYS.brainstorm_minimax,
  },
  '1ee4dcf6-b00d-49b3-b4d5-ec55d102fd40': {
    icon: 'IcEdit',
    placeholder: PROMPT_EDITOR_KEYS.writeArticle_placeholder,
    name: PROMPT_EDITOR_KEYS.writeArticle_name,
    id: '1ee4dcf6-b00d-49b3-b4d5-ec55d102fd40',
    type: 'Blog',
    minimax: PROMPT_EDITOR_KEYS.writeArticle_minimax,
  },
  '0fcb00ae-f47b-426f-9045-25798361ccc4': {
    icon: 'IcEdit',
    placeholder: PROMPT_EDITOR_KEYS.writeOutline_placeholder,
    name: PROMPT_EDITOR_KEYS.writeOutline_name,
    id: '0fcb00ae-f47b-426f-9045-25798361ccc4',
    type: 'Outline',
    minimax: PROMPT_EDITOR_KEYS.writeOutline_minimax,
  },
  'a15c829b-8861-47d8-a085-10e7b36d1841': {
    icon: 'IcEdit',
    placeholder: PROMPT_EDITOR_KEYS.writeStory_placeholder,
    name: PROMPT_EDITOR_KEYS.writeStory_name,
    id: 'a15c829b-8861-47d8-a085-10e7b36d1841',
    type: 'Story',
    minimax: PROMPT_EDITOR_KEYS.writeStory_minimax,
  },
  'b3d48333-ead2-4692-ab51-1f16019500cd': {
    icon: 'IcEdit',
    placeholder: PROMPT_EDITOR_KEYS.dailyNotes_placeholder,
    name: PROMPT_EDITOR_KEYS.dailyNotes_name,
    id: 'b3d48333-ead2-4692-ab51-1f16019500cd',
    type: 'DailyNotes',
    minimax: PROMPT_EDITOR_KEYS.dailyNotes_minimax,
  },
  'e7e1df60-bd16-47d9-a2fa-e4fec4c114cf': {
    icon: 'IcEdit',
    placeholder: PROMPT_EDITOR_KEYS.prosConAnalysis_placeholder,
    name: PROMPT_EDITOR_KEYS.prosConAnalysis_name,
    id: 'e7e1df60-bd16-47d9-a2fa-e4fec4c114cf',
    type: 'ProsAndConsList',
    minimax: PROMPT_EDITOR_KEYS.prosConAnalysis_minimax,
  },
  'f2eb1bda-7e1f-4ece-91d1-4c2c2d1f06cf': {
    icon: 'IcEdit',
    placeholder: PROMPT_EDITOR_KEYS.listActionItems_placeholder,
    name: PROMPT_EDITOR_KEYS.listActionItems_name,
    id: 'f2eb1bda-7e1f-4ece-91d1-4c2c2d1f06cf',
    type: 'ActionItems',
    minimax: PROMPT_EDITOR_KEYS.listActionItems_minimax,
  },
  'f2eb1bda-7e1f-4ece-91d1-4c2c2d1f06cc': {
    icon: 'IcEdit',
    name: PROMPT_EDITOR_KEYS.explainVariant_name,
    id: 'f2eb1bda-7e1f-4ece-91d1-4c2c2d1f06cc',
    type: 'explain',
    minimax: PROMPT_EDITOR_KEYS.explainVariant_minimax,
  },
  'f2eb1bda-7e1f-4ece-91d1-4c2c2daf06cd': {
    icon: 'IcTable',
    name: PROMPT_EDITOR_KEYS.draftMultiTable_name,
    id: 'f2eb1bda-7e1f-4ece-91d1-4c2c2daf06cd',
    subNodes: [
      '5f4bf941-d35e-4d1e-96c3-976a4f8ab1d1',
      'c9f301a3-35ec-4ab9-8b2d-ef74340a4701',
      '6485520b-3dbc-469a-99b6-c7ecf4217a56',
      'b177392a-b4c8-45cf-b834-1378d317aa94',
    ],
  },
  '5f4bf941-d35e-4d1e-96c3-976a4f8ab1d1': {
    placeholder: PROMPT_EDITOR_KEYS.writePlan_placeholder,
    name: PROMPT_EDITOR_KEYS.writePlan_name,
    id: '5f4bf941-d35e-4d1e-96c3-976a4f8ab1d1',
    type: 'plan',
    minimax: PROMPT_EDITOR_KEYS.writePlan_minimax,
  },
  'c9f301a3-35ec-4ab9-8b2d-ef74340a4701': {
    placeholder: PROMPT_EDITOR_KEYS.writeList_placeholder,
    name: PROMPT_EDITOR_KEYS.writeList_name,
    id: 'c9f301a3-35ec-4ab9-8b2d-ef74340a4701',
    type: 'list',
    minimax: PROMPT_EDITOR_KEYS.writeList_minimax,
  },
  '6485520b-3dbc-469a-99b6-c7ecf4217a56': {
    placeholder: PROMPT_EDITOR_KEYS.taskManagement_placeholder,
    name: PROMPT_EDITOR_KEYS.taskManagement_name,
    id: '6485520b-3dbc-469a-99b6-c7ecf4217a56',
    type: 'task',
    minimax: PROMPT_EDITOR_KEYS.taskManagement_minimax,
  },
  'b177392a-b4c8-45cf-b834-1378d317aa94': {
    icon: 'IcTable',
    placeholder: '',
    name: PROMPT_EDITOR_KEYS.other_name,
    id: 'b177392a-b4c8-45cf-b834-1378d317aa94',
    type: 'other',
    minimax: PROMPT_EDITOR_KEYS.other_minimax,
  },
  'f2eb1bda-7e1f-4ece-9121-4c2c1daf06cd': {
    icon: 'IcMindmap',
    name: PROMPT_EDITOR_KEYS.draftMindMap_name,
    id: 'f2eb1bda-7e1f-4ece-9121-4c2c1daf06cd',
    subNodes: [
      '0f74c3ef-efbc-41ae-b6fb-04dd8e429d3d',
      '6d5d4666-94f8-471e-84e9-ae80acb50b39',
      'bd6048f5-b856-42aa-968e-b93c781679a3',
    ],
  },
  '0f74c3ef-efbc-41ae-b6fb-04dd8e429d3d': {
    name: PROMPT_EDITOR_KEYS.mindOutline_name,
    id: '0f74c3ef-efbc-41ae-b6fb-04dd8e429d3d',
    type: 'mindOutline',
    minimax: PROMPT_EDITOR_KEYS.mindOutline_minimax,
  },
  '6d5d4666-94f8-471e-84e9-ae80acb50b39': {
    name: PROMPT_EDITOR_KEYS.mindPlan_name,
    id: '6d5d4666-94f8-471e-84e9-ae80acb50b39',
    type: 'mindPlan',
    minimax: PROMPT_EDITOR_KEYS.mindPlan_minimax,
  },
  'bd6048f5-b856-42aa-968e-b93c781679a3': {
    name: PROMPT_EDITOR_KEYS.mindOther_name,
    id: 'bd6048f5-b856-42aa-968e-b93c781679a3',
    type: 'mindOther',
    minimax: PROMPT_EDITOR_KEYS.mindOther_minimax,
  },
};

const zhRecords = {
  '9aab88e9-ba1b-4201-a9f3-483e814493db': {
    icon: 'IcEdit',
    name: PROMPT_EDITOR_KEYS.continueWriting_name,
    id: '9aab88e9-ba1b-4201-a9f3-483e814493db',
    type: 'ContinueWrite',
    minimax: PROMPT_EDITOR_KEYS.continueWriting_minimax,
  },
  '7aec37fa-f6be-4b6e-a870-6a54b430131a': {
    icon: 'IcSummarize',
    name: PROMPT_EDITOR_KEYS.summarize_name,
    id: '7aec37fa-f6be-4b6e-a870-6a54b430131a',
    type: 'Summarize',
    minimax: PROMPT_EDITOR_KEYS.summarize_minimax,
  },
  'c0e29509-ca71-4bc0-9a96-fa338a2b05ce': {
    icon: 'IcAbstract',
    name: PROMPT_EDITOR_KEYS.keySummary_name,
    id: 'c0e29509-ca71-4bc0-9a96-fa338a2b05ce',
    type: 'keySummary',
    minimax: PROMPT_EDITOR_KEYS.keySummary_minimax,
  },
  '5e936d14-2331-468b-af24-31433992451d': {
    icon: 'IcQuestion',
    name: PROMPT_EDITOR_KEYS.explain_name,
    id: '5e936d14-2331-468b-af24-31433992451d',
    type: 'explain',
    minimax: PROMPT_EDITOR_KEYS.explain_minimax,
  },
  '5e936d14-2331-468b-af24-31433994451d': {
    icon: 'IcTranslate',
    name: PROMPT_EDITOR_KEYS.translate_name,
    id: '5e936d14-2331-468b-af24-31433994451d',
    subNodes: [
      '3a36576b-1b95-42c5-b70a-5c36fc9e145d',
      'fb5a9fbd-c969-4bf4-baee-a0d0af4cb880',
      '8846070a-7630-42a0-9042-290ab143d389',
      '6ecd1645-fadb-4f56-bec5-cb1877d16330',
      '069f3964-62a0-4094-96f9-b993dae8cc47',
      '9151b1e0-e57f-45fa-b4b2-3942ed8437e3',
      '459fee87-5cfc-4166-8b49-4060d4c27e2f',
      '459fee87-5cfc-4166-8b49-4060d4c27e22',
    ],
  },
  '3a36576b-1b95-42c5-b70a-5c36fc9e145d': {
    name: PROMPT_EDITOR_KEYS.simplifiedChinese_name,
    id: '3a36576b-1b95-42c5-b70a-5c36fc9e145d',
    type: 'simplified chinese',
    minimax: PROMPT_EDITOR_KEYS.simplifiedChinese_minimax,
  },
  'fb5a9fbd-c969-4bf4-baee-a0d0af4cb880': {
    name: PROMPT_EDITOR_KEYS.classicalChinese_name,
    id: 'fb5a9fbd-c969-4bf4-baee-a0d0af4cb880',
    type: 'classical chinese',
    minimax: PROMPT_EDITOR_KEYS.classicalChinese_minimax,
  },
  '8846070a-7630-42a0-9042-290ab143d389': {
    name: PROMPT_EDITOR_KEYS.english_name,
    id: '8846070a-7630-42a0-9042-290ab143d389',
    type: 'english',
    minimax: PROMPT_EDITOR_KEYS.english_minimax,
  },
  '6ecd1645-fadb-4f56-bec5-cb1877d16330': {
    name: PROMPT_EDITOR_KEYS.korean_name,
    id: '6ecd1645-fadb-4f56-bec5-cb1877d16330',
    type: 'korean',
    minimax: PROMPT_EDITOR_KEYS.korean_minimax,
  },
  '069f3964-62a0-4094-96f9-b993dae8cc47': {
    name: PROMPT_EDITOR_KEYS.japanese_name,
    id: '069f3964-62a0-4094-96f9-b993dae8cc47',
    type: 'japanese',
    minimax: PROMPT_EDITOR_KEYS.japanese_minimax,
  },
  '9151b1e0-e57f-45fa-b4b2-3942ed8437e3': {
    name: PROMPT_EDITOR_KEYS.french_name,
    id: '9151b1e0-e57f-45fa-b4b2-3942ed8437e3',
    type: 'french',
    minimax: PROMPT_EDITOR_KEYS.french_minimax,
  },
  '459fee87-5cfc-4166-8b49-4060d4c27e2f': {
    name: PROMPT_EDITOR_KEYS.german_name,
    id: '459fee87-5cfc-4166-8b49-4060d4c27e2f',
    type: 'german',
    minimax: PROMPT_EDITOR_KEYS.german_minimax,
  },
  '459fee87-5cfc-4166-8b49-4060d4c27e22': {
    name: PROMPT_EDITOR_KEYS.translateTo_name,
    id: '459fee87-5cfc-4166-8b49-4060d4c27e22',
    type: 'OtherLanguage',
    minimax: PROMPT_EDITOR_KEYS.translateTo_minimax,
  },
  '7edcb487-2041-4ade-8483-71b9e1caba35': {
    icon: 'IcChangeWriting',
    name: PROMPT_EDITOR_KEYS.improveWriting_name,
    id: '7edcb487-2041-4ade-8483-71b9e1caba35',
    type: 'Improve',
    minimax: PROMPT_EDITOR_KEYS.improveWriting_minimax,
  },
  '1a8812df-9395-4eed-84be-59b5e148e7c1': {
    icon: 'IcSimpler',
    name: PROMPT_EDITOR_KEYS.makeShorter_name,
    id: '1a8812df-9395-4eed-84be-59b5e148e7c1',
    type: 'makeShorter',
    minimax: PROMPT_EDITOR_KEYS.makeShorter_minimax,
  },
  '63c58833-d02c-4a15-8039-949c78bcc9f2': {
    icon: 'IcMoreDetail',
    name: PROMPT_EDITOR_KEYS.makeLonger_name,
    id: '63c58833-d02c-4a15-8039-949c78bcc9f2',
    type: 'makeLonger',
    minimax: PROMPT_EDITOR_KEYS.makeLonger_minimax,
  },
  '7613737d-eb65-4464-a596-167d1e3f0c00': {
    icon: 'IcAiStyle',
    name: PROMPT_EDITOR_KEYS.switchStyle_name,
    id: '7613737d-eb65-4464-a596-167d1e3f0c00',
    subNodes: [
      '32faf939-cb35-479f-95e8-3a234791a75d',
      '68dc99f8-ebda-440e-bd9d-b1d431b24e0a',
      'f57e6b90-d5c3-453a-87ab-e6ed9d2c175f',
      '06d15689-21c4-446d-89b0-fa5cc33c3d96',
      '6a8e29b8-e6ee-4af1-87da-212f01b7925a',
    ],
  },
  '32faf939-cb35-479f-95e8-3a234791a75d': {
    name: PROMPT_EDITOR_KEYS.moreProfessional_name,
    id: '32faf939-cb35-479f-95e8-3a234791a75d',
    type: 'professional',
    minimax: PROMPT_EDITOR_KEYS.moreProfessional_minimax,
  },
  '68dc99f8-ebda-440e-bd9d-b1d431b24e0a': {
    name: PROMPT_EDITOR_KEYS.informal_name,
    id: '68dc99f8-ebda-440e-bd9d-b1d431b24e0a',
    type: 'casual',
    minimax: PROMPT_EDITOR_KEYS.informal_minimax,
  },
  'f57e6b90-d5c3-453a-87ab-e6ed9d2c175f': {
    name: PROMPT_EDITOR_KEYS.moreDirect_name,
    id: 'f57e6b90-d5c3-453a-87ab-e6ed9d2c175f',
    type: 'straightforward',
    minimax: PROMPT_EDITOR_KEYS.moreDirect_minimax,
  },
  '06d15689-21c4-446d-89b0-fa5cc33c3d96': {
    name: PROMPT_EDITOR_KEYS.moreConfident_name,
    id: '06d15689-21c4-446d-89b0-fa5cc33c3d96',
    type: 'confident',
    minimax: PROMPT_EDITOR_KEYS.moreConfident_minimax,
  },
  '6a8e29b8-e6ee-4af1-87da-212f01b7925a': {
    name: PROMPT_EDITOR_KEYS.moreFriendly_name,
    id: '6a8e29b8-e6ee-4af1-87da-212f01b7925a',
    type: 'friendly',
    minimax: PROMPT_EDITOR_KEYS.moreFriendly_minimax,
  },
  'bc56080a-edb8-46e2-8584-7be4c4cc5d05': {
    icon: 'IcEdit',
    placeholder: PROMPT_EDITOR_KEYS.brainstorm_placeholder,
    name: PROMPT_EDITOR_KEYS.brainstorm_name,
    id: 'bc56080a-edb8-46e2-8584-7be4c4cc5d05',
    type: 'Brainstorm',
    minimax: PROMPT_EDITOR_KEYS.brainstorm_minimax,
  },
  '1ee4dcf6-b00d-49b3-b4d5-ec55d102fd40': {
    icon: 'IcEdit',
    placeholder: PROMPT_EDITOR_KEYS.writeArticle_placeholder,
    name: PROMPT_EDITOR_KEYS.writeArticle_name,
    id: '1ee4dcf6-b00d-49b3-b4d5-ec55d102fd40',
    type: 'Blog',
    minimax: PROMPT_EDITOR_KEYS.writeArticle_minimax,
  },
  '0fcb00ae-f47b-426f-9045-25798361ccc4': {
    icon: 'IcEdit',
    placeholder: PROMPT_EDITOR_KEYS.writeOutline_placeholder,
    name: PROMPT_EDITOR_KEYS.writeOutline_name,
    id: '0fcb00ae-f47b-426f-9045-25798361ccc4',
    type: 'Outline',
    minimax: PROMPT_EDITOR_KEYS.writeOutline_minimax,
  },
  'a15c829b-8861-47d8-a085-10e7b36d1841': {
    icon: 'IcEdit',
    placeholder: PROMPT_EDITOR_KEYS.writeStory_placeholder,
    name: PROMPT_EDITOR_KEYS.writeStory_name,
    id: 'a15c829b-8861-47d8-a085-10e7b36d1841',
    type: 'Story',
    minimax: PROMPT_EDITOR_KEYS.writeStory_minimax,
  },
  'b3d48333-ead2-4692-ab51-1f16019500cd': {
    icon: 'IcEdit',
    placeholder: PROMPT_EDITOR_KEYS.dailyNotes_placeholder,
    name: PROMPT_EDITOR_KEYS.dailyNotes_name,
    id: 'b3d48333-ead2-4692-ab51-1f16019500cd',
    type: 'DailyNotes',
    minimax: PROMPT_EDITOR_KEYS.dailyNotes_minimax,
  },
  'e7e1df60-bd16-47d9-a2fa-e4fec4c114cf': {
    icon: 'IcEdit',
    placeholder: PROMPT_EDITOR_KEYS.prosConAnalysis_placeholder,
    name: PROMPT_EDITOR_KEYS.prosConAnalysis_name,
    id: 'e7e1df60-bd16-47d9-a2fa-e4fec4c114cf',
    type: 'ProsAndConsList',
    minimax: PROMPT_EDITOR_KEYS.prosConAnalysis_minimax,
  },
  'f2eb1bda-7e1f-4ece-91d1-4c2c2d1f06cf': {
    icon: 'IcEdit',
    placeholder: PROMPT_EDITOR_KEYS.listActionItems_placeholder,
    name: PROMPT_EDITOR_KEYS.listActionItems_name,
    id: 'f2eb1bda-7e1f-4ece-91d1-4c2c2d1f06cf',
    type: 'ActionItems',
    minimax: PROMPT_EDITOR_KEYS.listActionItems_minimax,
  },
  'f2eb1bda-7e1f-4ece-91d1-4c2c2d1f06cc': {
    icon: 'IcEdit',
    name: PROMPT_EDITOR_KEYS.explainVariant_name,
    id: 'f2eb1bda-7e1f-4ece-91d1-4c2c2d1f06cc',
    type: 'explain',
    minimax: PROMPT_EDITOR_KEYS.explainVariant_minimax,
  },
  'f2eb1bda-7e1f-4ece-91d1-4c2c2daf06cd': {
    icon: 'IcTable',
    name: PROMPT_EDITOR_KEYS.draftMultiTable_name,
    id: 'f2eb1bda-7e1f-4ece-91d1-4c2c2daf06cd',
    subNodes: [
      '5f4bf941-d35e-4d1e-96c3-976a4f8ab1d1',
      'c9f301a3-35ec-4ab9-8b2d-ef74340a4701',
      '6485520b-3dbc-469a-99b6-c7ecf4217a56',
      'b177392a-b4c8-45cf-b834-1378d317aa94',
    ],
  },
  '5f4bf941-d35e-4d1e-96c3-976a4f8ab1d1': {
    placeholder: PROMPT_EDITOR_KEYS.writePlan_placeholder,
    name: PROMPT_EDITOR_KEYS.writePlan_name,
    id: '5f4bf941-d35e-4d1e-96c3-976a4f8ab1d1',
    type: 'plan',
    minimax: PROMPT_EDITOR_KEYS.writePlan_minimax,
  },
  'c9f301a3-35ec-4ab9-8b2d-ef74340a4701': {
    placeholder: PROMPT_EDITOR_KEYS.writeList_placeholder,
    name: PROMPT_EDITOR_KEYS.writeList_name,
    id: 'c9f301a3-35ec-4ab9-8b2d-ef74340a4701',
    type: 'list',
    minimax: PROMPT_EDITOR_KEYS.writeList_minimax,
  },
  '6485520b-3dbc-469a-99b6-c7ecf4217a56': {
    placeholder: PROMPT_EDITOR_KEYS.taskManagement_placeholder,
    name: PROMPT_EDITOR_KEYS.taskManagement_name,
    id: '6485520b-3dbc-469a-99b6-c7ecf4217a56',
    type: 'task',
    minimax: PROMPT_EDITOR_KEYS.taskManagement_minimax,
  },
  'b177392a-b4c8-45cf-b834-1378d317aa94': {
    placeholder: '',
    name: PROMPT_EDITOR_KEYS.other_name,
    id: 'b177392a-b4c8-45cf-b834-1378d317aa94',
    type: 'other',
    minimax: PROMPT_EDITOR_KEYS.other_minimax,
  },
  'f2eb1bda-7e1f-4ece-9121-4c2c1daf06cd': {
    icon: 'IcMindmap',
    name: PROMPT_EDITOR_KEYS.draftMindMap_name,
    id: 'f2eb1bda-7e1f-4ece-9121-4c2c1daf06cd',
    subNodes: [
      '0f74c3ef-efbc-41ae-b6fb-04dd8e429d3d',
      '6d5d4666-94f8-471e-84e9-ae80acb50b39',
      'bd6048f5-b856-42aa-968e-b93c781679a3',
    ],
  },
  '0f74c3ef-efbc-41ae-b6fb-04dd8e429d3d': {
    name: PROMPT_EDITOR_KEYS.mindOutline_name,
    id: '0f74c3ef-efbc-41ae-b6fb-04dd8e429d3d',
    type: 'mindOutline',
    minimax: PROMPT_EDITOR_KEYS.mindOutline_minimax,
  },
  '6d5d4666-94f8-471e-84e9-ae80acb50b39': {
    name: PROMPT_EDITOR_KEYS.mindPlan_name,
    id: '6d5d4666-94f8-471e-84e9-ae80acb50b39',
    type: 'mindPlan',
    minimax: PROMPT_EDITOR_KEYS.mindPlan_minimax,
  },
  'bd6048f5-b856-42aa-968e-b93c781679a3': {
    name: PROMPT_EDITOR_KEYS.mindOther_name,
    id: 'bd6048f5-b856-42aa-968e-b93c781679a3',
    type: 'mindOther',
    minimax: PROMPT_EDITOR_KEYS.mindOther_minimax,
  },
};

/** System preset prompts */
export const systemPromptData: Omit<PromptStore, 'alreadySaved'> = {
  editPrompts: [
    '9aab88e9-ba1b-4201-a9f3-483e814493db',
    '7aec37fa-f6be-4b6e-a870-6a54b430131a',
    'c0e29509-ca71-4bc0-9a96-fa338a2b05ce',
    '5e936d14-2331-468b-af24-31433992451d',
    '5e936d14-2331-468b-af24-31433994451d',
    '7edcb487-2041-4ade-8483-71b9e1caba35',
    '1a8812df-9395-4eed-84be-59b5e148e7c1',
    '63c58833-d02c-4a15-8039-949c78bcc9f2',
    '7613737d-eb65-4464-a596-167d1e3f0c00',
  ],
  emptyWithPrompts: [
    'bc56080a-edb8-46e2-8584-7be4c4cc5d05',
    '1ee4dcf6-b00d-49b3-b4d5-ec55d102fd40',
    '0fcb00ae-f47b-426f-9045-25798361ccc4',
    'a15c829b-8861-47d8-a085-10e7b36d1841',
    'b3d48333-ead2-4692-ab51-1f16019500cd',
    'e7e1df60-bd16-47d9-a2fa-e4fec4c114cf',
    'f2eb1bda-7e1f-4ece-91d1-4c2c2d1f06cf',
    'f2eb1bda-7e1f-4ece-91d1-4c2c2d1f06cc',
    'f2eb1bda-7e1f-4ece-91d1-4c2c2daf06cd',
    'f2eb1bda-7e1f-4ece-9121-4c2c1daf06cd',
  ],
  records: __BUILD_IN__ ? enRecords : zhRecords,
};

const fixIconName = (name?: string) => {
  if (!name) return;
  if (name === 'ic_table_24') {
    name = 'ic_table_ai';
  }
  if (name.includes('_')) {
    const splitArr = name.split('_');
    const fixed = splitArr.map((v) => firstToUpperCase(v)).join('');
    return fixed;
  }
  return name;
};
const firstToUpperCase = (text: string) => {
  if (text.length > 0) {
    const first = text.slice(0, 1).toUpperCase();
    const rest = text.slice(1);
    return first + rest;
  }
  return text;
};
export const PROMPT_SUFFIX = '\n"""\n{input}\n"""';
const fixContent = (text?: string) => {
  if (!text) return;
  return `${text}${PROMPT_SUFFIX}`;
};
// fix
const keys = Object.keys(systemPromptData.records);
for (const key of keys) {
  const v = systemPromptData.records[key]!;
  systemPromptData.records[key] = {
    ...v,
    icon: fixIconName(v.icon),
    minimax: fixContent(v.minimax),
  };
}
/** Check if a prompt ID is a system preset */
export const isSystemPrompt = (promptId?: string) => {
  if (!promptId) return false;
  return !!systemPromptData.records[promptId];
};
